<template>
<div>
    <div class="float-lg-right mb-3">
        <download-excel :fetch="fetchData" class="btn btn-outline-success default" :fields="json_fields" name="salesCouponList.xls">Excel
        </download-excel>
    </div>
    <b-table-simple head-variant="light" class="vuetable" responsive>
        <b-thead head-variant="light">
            <b-tr>
                <template v-for="(field , idx) in fields">
                    <b-th style="text-align: center" :key="idx" >{{ field.label }}</b-th>
                </template>
            </b-tr>
        </b-thead>
        <b-tbody>
            <template v-for="(item , i ) in goodsData">

                <b-tr :key="i" v-if="Number(item.listPriceTotal )>= 0" >
                    <!-- <b-td>{{ item }}</b-td> -->
                    <b-td style="text-align:center">{{ goodsTypeVal(item.goodsType) }}</b-td>
                    <b-td style="text-align:center">{{ item.goodsName }}</b-td>
                    <b-td style="text-align:center">{{ item.optionName }}</b-td>
                    <b-td style="text-align:center">{{ item.count | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.listPriceTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.originalSalesAmountTotal | currency }}</b-td>
                    <b-td style="text-align:center">{{ item.salesAmountTotal | currency }}</b-td>
                </b-tr>
                <b-tr :key="i" v-else >
                    <!-- <b-td>{{ item }}</b-td> -->
                    <b-td style="text-align:center; color: red;">{{ goodsTypeVal(item.goodsType) }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.goodsName }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.optionName }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.count | currency }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.listPriceTotal | currency }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.originalSalesAmountTotal | currency }}</b-td>
                    <b-td style="text-align:center; color: red;">{{ item.salesAmountTotal | currency }}</b-td>
                </b-tr>

            </template>

            <template>
                <b-tr>
                    <b-th style="text-align: center; background: rgb(246, 199, 151) !important;">합계 :</b-th>
                    <b-th style="text-align: center; background: rgb(246, 199, 151) !important;"></b-th>
                    <b-th style="text-align: center; background: rgb(246, 199, 151) !important;"></b-th>
                    <b-th v-if="totalData('count') >=0" style="text-align: center; background: rgb(246, 199, 151) !important;">{{ totalData('count')}}</b-th>
                    <b-th v-else style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('count')}}</b-th>
                    <b-th v-if="totalData('listPriceTotal') >=0" style="text-align: center; background: rgb(246, 199, 151) !important;">{{ totalData('listPriceTotal') | currency}}</b-th>
                    <b-th v-else style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('listPriceTotal') | currency}}</b-th>
                    <b-th v-if="totalData('originalSalesAmountTotal') >=0" style="text-align: center; background: rgb(246, 199, 151) !important;">{{ totalData('originalSalesAmountTotal') | currency}}</b-th>
                    <b-th v-else style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('originalSalesAmountTotal') | currency}}</b-th>
                    <b-th v-if="totalData('salesAmountTotal') >=0" style="text-align: center; background: rgb(246, 199, 151) !important;">{{ totalData('salesAmountTotal') | currency}}</b-th>
                    <b-th v-else style="text-align: center; background: rgb(246, 199, 151) !important; color: red;">{{ totalData('salesAmountTotal') | currency}}</b-th>
                </b-tr>
            </template>
        </b-tbody>
    </b-table-simple>
    <!--    <b-pagination size="sm"-->
    <!--                  align="center"-->
    <!--                  :total-rows="total"-->
    <!--                  :per-page="perPage"-->
    <!--                  v-model="currentPage"-->
    <!--    >-->
    <!--      <template v-slot:next-text>-->
    <!--        <i class="simple-icon-arrow-right"/>-->
    <!--      </template>-->
    <!--      <template v-slot:prev-text>-->
    <!--        <i class="simple-icon-arrow-left"/>-->
    <!--      </template>-->
    <!--      <template v-slot:first-text>-->
    <!--        <i class="simple-icon-control-start"/>-->
    <!--      </template>-->
    <!--      <template v-slot:last-text>-->
    <!--        <i class="simple-icon-control-end"/>-->
    <!--      </template>-->
    <!--    </b-pagination>-->

</div>
</template>

<script>
import {
    mapGetters,
} from "vuex";
import {
    alignTableCenter,
    currencyFilter,
    getGoodsTypeStr,
} from "../../../utils";

export default {
    components: {},
    props: ['data'],
    filters: {
        ...currencyFilter
    },
    data() {
        return {
            total: 0,
            currentPage: 1,
            perPage: 10,
            item: null,
            searchDate: null,
            goodsType: null,
            couponList: [],
            goodsData: [],
            fields: [{
                    key: "goodsType",
                    label: "상품구분",
                    ...alignTableCenter
                },
                {
                    key: "goodsName",
                    label: "상품명",
                    ...alignTableCenter
                },
                {
                    key: "optionName",
                    label: "옵션명",
                    ...alignTableCenter
                },
                {
                    key: "count",
                    label: "건수",
                    ...alignTableCenter
                },
                {
                    key: "listPriceTotal",
                    label: "정상가",
                    ...alignTableCenter
                },
                {
                    key: "originalSalesAmountTotal",
                    label: "판매가",
                    ...alignTableCenter
                },
                {
                    key: "salesAmountTotal",
                    label: "실판매가",
                    ...alignTableCenter
                },
                // {key: "netPrice", label: "입금액", ...alignTableCenter},
            ],
            json_fields: {
                '상품구분': 'goodsType',
                '상품명': 'goodsName',
                '옵션명': 'optionName',
                '건수': 'count',
                '정상가': 'listPriceTotal',
                '판매가': 'originalSalesAmountTotal',
                '실판매가': 'salesAmountTotal',
            },
            json_meta: [
                [{
                    'key': 'charset',
                    'value': 'utf-8'
                }]
            ],
            excelData: []
        }
    },
    computed: {},
    mounted() {},
    methods: {
        goodsTypeVal(val) {
            return getGoodsTypeStr(val);
        },
        penaltyCountN(){
            let penaltyCount = 0;
            this.goodsData.forEach((el) => {
                if(el.penaltyCount !== NaN){
                    penaltyCount += Number(el.penaltyCount);
                }
            });
            return penaltyCount ;
        },
        totalData(data) {
            let count = 0,
                originalSalesAmountTotal = 0,
                listPriceTotal = 0,
                salesAmountTotal = 0
            this.goodsData.forEach((el) => {
                count += Number(el.count);
                originalSalesAmountTotal += Number(el.originalSalesAmountTotal);
                listPriceTotal += Number(el.listPriceTotal);
                salesAmountTotal += Number(el.salesAmountTotal);
            });
            if (data == "count") {
                return count;
            } else if (data == "originalSalesAmountTotal") {
                return originalSalesAmountTotal;
            } else if (data == "listPriceTotal") {
                return listPriceTotal;
            } else if (data == "salesAmountTotal") {
                return salesAmountTotal;
            }

        },
        init(date, goodsType, item) {
            this.searchDate = date
            this.goodsType = goodsType
            this.item = item
            this.loadData()
        },

        loadData() {
            console.log(this.item);
            /**
             * 1. 특정날짜, 특정상품유형
             * 2. 모든날짜, 특정상품유형(하단합계)
             * 3. 특정날짜, 모든상품유형
             * 4. 모든날짜, 모든상품유형(우측합계)
             */
            const vm = this
            this.couponList = []
            this.goodsData = []

            if (this.searchDate == null) { //모든날짜

                this.item.forEach(function (v, index) {

                    //goodsType : Default, SelfSales, Summary(판매현황)
                    if (vm.goodsType == null) {
                        v.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.Default != null && (vm.goodsType == "Default" || vm.goodsType == "Summary")) {
                        v.Default.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }

                    if (v.SelfSales != null && (vm.goodsType == "SelfSales" || vm.goodsType == "Summary")) {
                        v.SelfSales.goods.forEach(function (vv, index) {
                            vm.couponList.push(vv)
                        })
                    }
                })

            } else { //특정날짜

                if (this.item.Default != null && (this.goodsType == "Default" || this.goodsType == "Summary")) {
                    this.item.Default.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }

                if (this.item.SelfSales != null && (this.goodsType == "SelfSales" || this.goodsType == "Summary")) {
                    this.item.SelfSales.goods.forEach(function (value, index) {
                        vm.couponList.push(value)
                    })
                }

            }

            // console.log("couponList", vm.couponList);

            this.couponList.forEach((v) => {
                v.options.forEach((vv) => {

                    if (vm.goodsData.length > 0) {
                        let flag = false;
                        let flagNum = null;
                        vm.goodsData.forEach((vvv, idx) => {
                            if (v.goodsName == vvv.goodsName && vv.optionName == vvv.optionName) {
                                flag = true;
                                flagNum = idx;
                            }
                        })

                        if (flag) {
                            vm.goodsData[flagNum].count = Number(vm.goodsData[flagNum].count) + Number(vv.transactionCount)
                            vm.goodsData[flagNum].listPriceTotal = Number(vm.goodsData[flagNum].listPriceTotal) + Number(vv.listPriceTotal)
                            vm.goodsData[flagNum].salesAmountTotal = Number(vm.goodsData[flagNum].salesAmountTotal) + Number(vv.salesAmountTotal)
                            vm.goodsData[flagNum].originalSalesAmountTotal = Number(vm.goodsData[flagNum].originalSalesAmountTotal) + Number(vv.originalSalesAmountTotal)

                        } else {
                            // let selseAt = 0;
                            // if (v.goodsType === 'StoreBooking') {
                            //     selseAt = vv.originalSalesAmountTotal - vv.discountAmountTotal;
                            // } else {
                            //     selseAt = vv.salesAmountTotal;
                            // }
                            vm.goodsData.push({
                                'goodsType': v.goodsType,
                                'goodsName': v.goodsName,
                                'optionName': vv.optionName,
                                'count': vv.transactionCount,
                                'listPriceTotal': vv.listPriceTotal,
                                'originalSalesAmountTotal': vv.originalSalesAmountTotal,
                                'salesAmountTotal': vv.salesAmountTotal,
                            })

                            console.log(vm.goodsData)

                        }
                    }else {
                        vm.goodsData.push({
                            'goodsType': v.goodsType,
                            'goodsName': v.goodsName,
                            'optionName': vv.optionName,
                            'count': vv.transactionCount,
                            'listPriceTotal': vv.listPriceTotal,
                            'originalSalesAmountTotal': vv.originalSalesAmountTotal,
                            'salesAmountTotal': vv.salesAmountTotal,
                        })
                    }

                })
            })

            // console.log(this.couponList);

            vm.goodsData.sort(function (a, b) {
                return a.goodsName < b.goodsName ? 1 : -1;
            });

        },
        async fetchData() {

            this.excelData = [];
            this.goodsData.forEach((v) => {
                this.excelData.push({
                    'goodsType': this.goodsTypeVal(v.goodsType),
                    'goodsName': v.goodsName,
                    'optionName': v.optionName,
                    'count': v.count,
                    'listPriceTotal': v.listPriceTotal,
                    'originalSalesAmountTotal': v.originalSalesAmountTotal,
                    'salesAmountTotal': v.salesAmountTotal,

                })
            })
            this.excelData.push({
                    'goodsType': '합계 :',
                    'count': this.totalData('count'),
                    'listPriceTotal': this.totalData('listPriceTotal'),
                    'originalSalesAmountTotal': this.totalData('originalSalesAmountTotal'),
                    'salesAmountTotal': this.totalData('salesAmountTotal'),

                })
            return this.excelData
        }
    }
}
</script>

<style scoped>
.table .thead-light th {
    border: 1px solid #fff !important;
    vertical-align: middle;
}
</style>
